// Lightweight tenant session, persisted in localStorage.
// Holds the active tenant's namespace + API key (JWT) so the whole GUI
// operates against one live tenant. No hardcoded namespaces anywhere.

const KEY = 'reright_session'

export function getSession() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null
  } catch {
    return null
  }
}

export function setSession(session) {
  localStorage.setItem(KEY, JSON.stringify(session))
  window.dispatchEvent(new Event('reright-session'))
}

export function clearSession() {
  localStorage.removeItem(KEY)
  window.dispatchEvent(new Event('reright-session'))
}

export function authHeaders() {
  const s = getSession()
  return s?.apiKey ? { Authorization: `Bearer ${s.apiKey}` } : {}
}
